module.exports = __webpack_public_path__ + "static/media/5C.12408f64.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/5C.svg
// module id = 65
// module chunks = 0